import { render, staticRenderFns } from "./ProfileHeader.vue?vue&type=template&id=938ca71e&scoped=true&"
import script from "./ProfileHeader.vue?vue&type=script&lang=ts&"
export * from "./ProfileHeader.vue?vue&type=script&lang=ts&"
import style0 from "./ProfileHeader.vue?vue&type=style&index=0&id=938ca71e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "938ca71e",
  null
  
)

export default component.exports